import React from 'react';

import { Typography } from '@mui/material';
import type { GridToolbarProps } from '@mui/x-data-grid-premium';
import { FiltersToolbarButton, SearchInput, Spacer } from 'src/components';
import { usePartyParams } from 'src/helpers';
import { useDataGridSearch } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

import { UploadDocumentsButton } from './UploadDocumentsButton';

const toolbarHeightPx = 52;

const useStyles = makeStyles()(theme => ({
  title: {
    flexShrink: 0,
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    maxHeight: toolbarHeightPx,
    minHeight: toolbarHeightPx,
  },
}));

export function PartyGridToolbar(_props: GridToolbarProps): JSX.Element | null {
  const { classes } = useStyles();
  const { partyId } = usePartyParams();
  const { search, setSearch } = useDataGridSearch();

  return (
    <div className={classes.toolbar}>
      <Typography className={classes.title} variant="h6">
        Documents
      </Typography>
      <FiltersToolbarButton />
      <Spacer />
      <SearchInput placeholder="Search" search={search} setSearch={setSearch} />
      <UploadDocumentsButton partyId={partyId} />
    </div>
  );
}

export function PartyDocumentsToolbar(props: GridToolbarProps): JSX.Element | null {
  return <PartyGridToolbar {...props} />;
}
